import React, { PropsWithChildren } from 'react';

const ThemeProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <>{children}</>
);

export default ThemeProvider;
